import React from 'react';
import { DarkModeProvider } from './components/context/DarkModeContext';
import { AuthProvider } from './components/context/AuthContext';
import { SuccessBarProvider } from './components/context/SuccessBarContext';
import { PopupProvider } from './components/context/PopupContext';
import { TourProvider } from './components/context/TourContext';
import { OfflineProvider } from './components/context/OfflineContext';
import Wrapper from './components/wrapper/Wrapper';
import SpotlightTour from './components/tour/SpotlightTour';
import IconLegendPopup from './components/tour/IconLegendPopup';

function App() {
  return (
    <DarkModeProvider>
      <PopupProvider>
        <AuthProvider>
          <SuccessBarProvider>
            <TourProvider>
              <OfflineProvider>
                <Wrapper />
                <SpotlightTour />
                <IconLegendPopup />
              </OfflineProvider>
            </TourProvider>
          </SuccessBarProvider>
        </AuthProvider>
      </PopupProvider>
    </DarkModeProvider>
  );
}

export default App;
